import { searchDropDownOptionMapping } from '@labrav/common'

export const getResaleAuthorizationSearchInput = (selectedOption: string) =>
  (
    searchDropDownOptionMapping.resaleAuthorizationOptions as Record<
      string,
      string
    >
  )[selectedOption]
